/* Configurateur de table AIRE — v2 (2026-09-16)
 * Visualisation 3D WebGL (sans dépendance) + option RAL sur mesure.
 * Chargé par snippets/tcfg-table.liquid ; s'initialise sur chaque [data-tcfg-root].
 */
(function () {
  'use strict';

  // ===========================================================================
  // i18n : dictionnaire JSON injecté par snippets/tcfg-i18n.liquid (#tcfg-i18n).
  // T(clé, repliFR, vars) -> texte traduit, sinon le français ; {jetons} remplacés.
  // Les propriétés envoyées au panier restent volontairement en français.
  // ===========================================================================
  var I18N = null;
  function i18n() {
    if (I18N) return I18N;
    var el = document.getElementById('tcfg-i18n');
    if (!el) return {};
    try { I18N = JSON.parse(el.textContent || '{}') || {}; } catch (e) { I18N = {}; }
    if (typeof I18N !== 'object') I18N = {};
    return I18N;
  }
  function T(key, fallbackFr, vars) {
    var d = i18n();
    var str = (typeof d[key] === 'string' && d[key]) ? d[key] : fallbackFr;
    if (vars) {
      for (var k in vars) {
        if (Object.prototype.hasOwnProperty.call(vars, k)) str = str.split('{' + k + '}').join(String(vars[k]));
      }
    }
    return str;
  }
  // Nom RAL affiché au client (traduit si dispo) ; entry.name (français) reste la valeur panier.
  function ralLabel(entry) {
    var m = i18n().ral;
    return (m && typeof m[entry.code] === 'string' && m[entry.code]) ? m[entry.code] : entry.name;
  }

  // ===========================================================================
  // Nuancier RAL Classic (teintes indicatives à l'écran)
  // ===========================================================================
  var RAL_DATA =
    '1000|Beige vert|BEBD7F;1001|Beige|C2B078;1002|Jaune sable|C6A664;1003|Jaune de sécurité|E5BE01;1004|Jaune or|CDA434;1005|Jaune miel|A98307;1006|Jaune maïs|E4A010;1007|Jaune narcisse|DC9D00;1011|Beige brun|8A6642;1012|Jaune citron|C7B446;1013|Blanc perlé|EAE6CA;1014|Ivoire|E1CC4F;1015|Ivoire clair|E6D690;1016|Jaune soufre|EDFF21;1017|Jaune safran|F5D033;1018|Jaune zinc|F8F32B;1019|Beige gris|9E9764;1020|Jaune olive|999950;1021|Jaune colza|F3DA0B;1023|Jaune signalisation|FAD201;1024|Jaune ocre|AEA04B;1026|Jaune brillant|FFFF00;1027|Jaune curry|9D9101;1028|Jaune melon|F4A900;1032|Jaune genêt|D6AE01;1033|Jaune dahlia|F3A505;1034|Jaune pastel|EFA94A;1035|Beige nacré|6A5D4D;1036|Or nacré|705335;1037|Jaune soleil|F39F18;' +
    '2000|Orangé jaune|ED760E;2001|Orangé rouge|C93C20;2002|Orangé sang|CB2821;2003|Orangé pastel|FF7514;2004|Orangé pur|F44611;2005|Orangé fluorescent|FF2301;2007|Orangé clair brillant|FFA420;2008|Orangé rouge clair|F75E25;2009|Orangé signalisation|F54021;2010|Orangé de sécurité|D84B20;2011|Orangé foncé|EC7C26;2012|Orangé saumon|E55137;2013|Orangé nacré|C35831;' +
    '3000|Rouge feu|AF2B1E;3001|Rouge de sécurité|A52019;3002|Rouge carmin|A2231D;3003|Rouge rubis|9B111E;3004|Rouge pourpre|75151E;3005|Rouge vin|5E2129;3007|Rouge noir|412227;3009|Rouge oxyde|642424;3011|Rouge brun|781F19;3012|Rouge beige|C1876B;3013|Rouge tomate|A12312;3014|Vieux rose|D36E70;3015|Rose clair|EA899A;3016|Rouge corail|B32821;3017|Rosé|E63244;3018|Rouge fraise|D53032;3020|Rouge signalisation|CC0605;3022|Rouge saumon|D95030;3024|Rouge brillant|F80000;3026|Rouge clair brillant|FE0000;3027|Rouge framboise|C51D34;3028|Rouge pur|CB3234;3031|Rouge oriental|B32428;3032|Rouge rubis nacré|721422;3033|Rose nacré|B44C43;' +
    '4001|Lilas rouge|6D3F5B;4002|Violet rouge|922B3E;4003|Violet bruyère|DE4C8A;4004|Violet bordeaux|641C34;4005|Lilas bleu|6C4675;4006|Pourpre signalisation|A03472;4007|Violet pourpre|4A192C;4008|Violet de sécurité|924E7D;4009|Violet pastel|A18594;4010|Telemagenta|CF3476;4011|Violet nacré|8673A1;4012|Mûre nacré|6C6874;' +
    '5000|Bleu violet|354D73;5001|Bleu vert|1F3438;5002|Bleu outremer|20214F;5003|Bleu saphir|1D1E33;5004|Bleu noir|18171C;5005|Bleu de sécurité|1E2460;5007|Bleu brillant|3E5F8A;5008|Bleu gris|26252D;5009|Bleu azur|025669;5010|Bleu gentiane|0E294B;5011|Bleu acier|231A24;5012|Bleu clair|3B83BD;5013|Bleu cobalt|1E213D;5014|Bleu pigeon|606E8C;5015|Bleu ciel|2271B3;5017|Bleu signalisation|063971;5018|Bleu turquoise|3F888F;5019|Bleu capri|1B5583;5020|Bleu océan|1D334A;5021|Bleu d\'eau|256D7B;5022|Bleu nocturne|252850;5023|Bleu distant|49678D;5024|Bleu pastel|5D9B9B;5025|Gentiane nacré|2A6478;5026|Bleu nuit nacré|102C54;' +
    '6000|Vert patine|316650;6001|Vert émeraude|287233;6002|Vert feuillage|2D572C;6003|Vert olive|424632;6004|Vert bleu|1F3A3D;6005|Vert mousse|2F4538;6006|Olive gris|3E3B32;6007|Vert bouteille|343B29;6008|Vert brun|39352A;6009|Vert sapin|31372B;6010|Vert herbe|35682D;6011|Vert réséda|587246;6012|Vert noir|343E40;6013|Vert jonc|6C7156;6014|Olive jaune|47402E;6015|Olive noir|3B3C36;6016|Vert turquoise|1E5945;6017|Vert mai|4C9141;6018|Vert jaune|57A639;6019|Vert blanc|BDECB6;6020|Vert oxyde chromique|2E3A23;6021|Vert pâle|89AC76;6022|Olive brun|25221B;6024|Vert signalisation|308446;6025|Vert fougère|3D642D;6026|Vert opale|015D52;6027|Vert clair|84C3BE;6028|Vert pin|2C5545;6029|Vert menthe|20603D;6032|Vert de sécurité|317F43;6033|Turquoise menthe|497E76;6034|Turquoise pastel|7FB5B5;6035|Vert nacré|1C542D;6036|Vert opale nacré|193737;6037|Vert pur|008F39;6038|Vert brillant|00BB2D;' +
    '7000|Gris petit-gris|78858B;7001|Gris argent|8A9597;7002|Gris olive|7E7B52;7003|Gris mousse|6C7059;7004|Gris de sécurité|969992;7005|Gris souris|646B63;7006|Gris beige|6D6552;7008|Gris kaki|6A5F31;7009|Gris vert|4D5645;7010|Gris tente|4C514A;7011|Gris fer|434B4D;7012|Gris basalte|4E5754;7013|Gris brun|464531;7015|Gris ardoise|434750;7016|Gris anthracite|293133;7021|Gris noir|23282B;7022|Gris terre d\'ombre|332F2C;7023|Gris béton|686C5E;7024|Gris graphite|474A51;7026|Gris granit|2F353B;7030|Gris pierre|8B8C7A;7031|Gris bleu|474B4E;7032|Gris silex|B8B799;7033|Gris ciment|7D8471;7034|Gris jaune|8F8B66;7035|Gris clair|D7D7D7;7036|Gris platine|7F7679;7037|Gris poussière|7D7F7D;7038|Gris agate|B5B8B1;7039|Gris quartz|6C6960;7040|Gris fenêtre|9DA1AA;7042|Gris signalisation A|8D948D;7043|Gris signalisation B|4E5452;7044|Gris soie|CAC4B0;7045|Telegris 1|909090;7046|Telegris 2|82898F;7047|Telegris 4|D0D0D0;7048|Gris souris nacré|898176;' +
    '8000|Brun vert|826C34;8001|Brun terre de Sienne|955F20;8002|Brun de sécurité|6C3B2A;8003|Brun argile|734222;8004|Brun cuivré|8E402A;8007|Brun fauve|59351F;8008|Brun olive|6F4F28;8011|Brun noisette|5B3A29;8012|Brun rouge|592321;8014|Brun sépia|382C1E;8015|Marron|633A34;8016|Brun acajou|4C2F27;8017|Brun chocolat|45322E;8019|Brun gris|403A3A;8022|Brun noir|212121;8023|Brun orangé|A65E2E;8024|Brun beige|79553D;8025|Brun pâle|755C48;8028|Brun terre|4E3B31;8029|Cuivre nacré|763C28;' +
    '9001|Blanc crème|FDF4E3;9002|Blanc gris|E7EBDA;9003|Blanc de sécurité|F4F4F4;9004|Noir de sécurité|282828;9005|Noir foncé|0A0A0A;9006|Aluminium blanc|A5A5A5;9007|Aluminium gris|8F8F8F;9010|Blanc pur|FFFFFF;9011|Noir graphite|1C1C1C;9016|Blanc signalisation|F6F6F6;9017|Noir signalisation|1E1E1E;9018|Blanc papyrus|D7D7D7;9022|Gris clair nacré|9C9C9C;9023|Gris foncé nacré|828282';

  var RAL = RAL_DATA.split(';').map(function (row) {
    var p = row.split('|');
    return { code: p[0], name: p[1], hex: '#' + p[2].toLowerCase() };
  });

  // ===========================================================================
  // Utilitaires
  // ===========================================================================
  function clamp01(v) { return Math.max(0, Math.min(1, v)); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  function formatEuroFRFromEuros(euros) {
    var n = isFinite(euros) ? euros : 0;
    var str = n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    str = str.replace(/ /g, ' ').replace(/ /g, ' ');
    return '€' + str;
  }

  function handleize(str) {
    str = (str || '').toString().trim().toLowerCase();
    try { str = str.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    str = str.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').replace(/-+/g, '-');
    return str;
  }
  function foldText(str) {
    str = (str || '').toString().toLowerCase();
    try { str = str.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    return str;
  }

  function hexToRgb(hex) {
    var h = (hex || '').replace('#', '').trim();
    if (h.length !== 6) return { r: 0, g: 166, b: 81 };
    return { r: parseInt(h.slice(0, 2), 16), g: parseInt(h.slice(2, 4), 16), b: parseInt(h.slice(4, 6), 16) };
  }
  function shadeRgb(rgb, k) {
    function f(v) { return Math.round(Math.max(0, Math.min(255, v + 255 * k))); }
    return { r: f(rgb.r), g: f(rgb.g), b: f(rgb.b) };
  }
  function rgbCss(rgb, a) {
    return 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + (a == null ? 1 : a) + ')';
  }
  function hexToLinear(hex) {
    var c = hexToRgb(hex);
    function lin(v) { v = v / 255; return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }
    return [lin(c.r), lin(c.g), lin(c.b)];
  }

  // ===========================================================================
  // Géométrie 2D : point dans polygone, rectangle inscrit, triangulation
  // ===========================================================================
  function pointInPoly(x, y, poly) {
    var inside = false;
    for (var i = 0, j = poly.length - 1; i < poly.length; j = i++) {
      var xi = poly[i].x, yi = poly[i].y;
      var xj = poly[j].x, yj = poly[j].y;
      var intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / ((yj - yi) || 1e-12) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  }
  function polyForTest(points) {
    if (!points || points.length < 3) return null;
    var p = points.slice();
    var a = p[0], b = p[p.length - 1];
    if (Math.abs(a.x - b.x) < 1e-6 && Math.abs(a.y - b.y) < 1e-6) p.pop();
    return p;
  }

  // plus grand rectangle axe-aligné inscrit (approx grille)
  function largestInscribedRect(polyPoints, nx, ny) {
    nx = nx || 86;
    ny = ny || 60;
    var FALLBACK = { x0: 0.12, x1: 0.88, y0: 0.12, y1: 0.88, ok: false };

    var poly = polyForTest(polyPoints);
    if (!poly || poly.length < 3) return FALLBACK;

    var inside = [];
    for (var y = 0; y < ny; y++) {
      inside[y] = new Array(nx);
      var py = (y + 0.5) / ny;
      for (var x = 0; x < nx; x++) {
        var px = (x + 0.5) / nx;
        inside[y][x] = pointInPoly(px, py, poly);
      }
    }

    var heights = new Array(nx);
    for (x = 0; x < nx; x++) heights[x] = 0;
    var best = { area: 0, x0: 0, x1: 0, y0: 0, y1: 0 };

    for (y = 0; y < ny; y++) {
      for (x = 0; x < nx; x++) heights[x] = inside[y][x] ? (heights[x] + 1) : 0;
      var stack = [];
      for (x = 0; x <= nx; x++) {
        var h = (x === nx) ? 0 : heights[x];
        while (stack.length && h < heights[stack[stack.length - 1]]) {
          var top = stack.pop();
          var height = heights[top];
          var right = x - 1;
          var left = stack.length ? (stack[stack.length - 1] + 1) : 0;
          var width = right - left + 1;
          var area = width * height;
          if (area > best.area) best = { area: area, x0: left, x1: right, y1: y, y0: y - height + 1 };
        }
        stack.push(x);
      }
    }
    if (best.area <= 0) return FALLBACK;

    var epsX = 0.5 / nx, epsY = 0.5 / ny;
    var x0 = clamp01((best.x0 / nx) + epsX);
    var x1 = clamp01(((best.x1 + 1) / nx) - epsX);
    var y0 = clamp01((best.y0 / ny) + epsY);
    var y1 = clamp01(((best.y1 + 1) / ny) - epsY);
    if (!(x1 > x0 && y1 > y0)) return FALLBACK;

    function cornersInside(xx0, xx1, yy0, yy1) {
      var c = [{ x: xx0, y: yy0 }, { x: xx1, y: yy0 }, { x: xx1, y: yy1 }, { x: xx0, y: yy1 }];
      for (var k = 0; k < c.length; k++) if (!pointInPoly(c[k].x, c[k].y, poly)) return false;
      return true;
    }
    if (!cornersInside(x0, x1, y0, y1)) {
      var sx = 1 / nx, sy = 1 / ny;
      for (var it = 0; it < 4; it++) {
        x0 += sx; x1 -= sx; y0 += sy; y1 -= sy;
        if (!(x1 > x0 && y1 > y0)) break;
        if (cornersInside(x0, x1, y0, y1)) break;
      }
    }
    if (!(x1 > x0 && y1 > y0)) return FALLBACK;
    return { x0: x0, x1: x1, y0: y0, y1: y1, ok: true };
  }

  // Nettoie un contour : retire le point de fermeture et les doublons consécutifs
  function cleanContour(points) {
    var out = [];
    for (var i = 0; i < points.length; i++) {
      var p = points[i];
      var q = out.length ? out[out.length - 1] : null;
      if (q && Math.abs(q.x - p.x) < 1e-5 && Math.abs(q.y - p.y) < 1e-5) continue;
      out.push({ x: p.x, y: p.y });
    }
    if (out.length > 1) {
      var a = out[0], b = out[out.length - 1];
      if (Math.abs(a.x - b.x) < 1e-5 && Math.abs(a.y - b.y) < 1e-5) out.pop();
    }
    return out;
  }

  function signedArea(pts) {
    var a = 0;
    for (var i = 0, n = pts.length; i < n; i++) {
      var p = pts[i], q = pts[(i + 1) % n];
      a += p.x * q.y - q.x * p.y;
    }
    return a * 0.5;
  }

  // Triangulation "ear clipping" (polygone simple) avec repli en éventail
  function triangulate(pts, fast) {
    var n = pts.length;
    if (n < 3) return [];
    if (n === 3) return [[0, 1, 2]];

    var tris = [];
    if (fast) return fanTriangulate(pts);

    var idx = [];
    var ccw = signedArea(pts) > 0;
    for (var i = 0; i < n; i++) idx.push(ccw ? i : (n - 1 - i));

    function cross(a, b, c) { return (b.x - a.x) * (c.y - a.y) - (b.y - a.y) * (c.x - a.x); }
    function inTri(p, a, b, c) {
      var d1 = cross(a, b, p), d2 = cross(b, c, p), d3 = cross(c, a, p);
      var hasNeg = (d1 < 0) || (d2 < 0) || (d3 < 0);
      var hasPos = (d1 > 0) || (d2 > 0) || (d3 > 0);
      return !(hasNeg && hasPos);
    }

    var guard = 0;
    while (idx.length > 3 && guard < 5000) {
      guard++;
      var found = false;
      var m = idx.length;
      for (i = 0; i < m; i++) {
        var i0 = idx[(i + m - 1) % m], i1 = idx[i], i2 = idx[(i + 1) % m];
        var a = pts[i0], b = pts[i1], c = pts[i2];
        if (cross(a, b, c) <= 1e-12) continue; // réflexe ou dégénéré
        var ear = true;
        for (var k = 0; k < m; k++) {
          var ik = idx[k];
          if (ik === i0 || ik === i1 || ik === i2) continue;
          var p = pts[ik];
          if ((Math.abs(p.x - a.x) < 1e-9 && Math.abs(p.y - a.y) < 1e-9) ||
              (Math.abs(p.x - c.x) < 1e-9 && Math.abs(p.y - c.y) < 1e-9)) continue;
          if (inTri(p, a, b, c)) { ear = false; break; }
        }
        if (!ear) continue;
        tris.push([i0, i1, i2]);
        idx.splice(i, 1);
        found = true;
        break;
      }
      if (!found) return fanTriangulate(pts); // contour auto-sécant : repli
    }
    if (idx.length === 3) tris.push([idx[0], idx[1], idx[2]]);
    return tris;
  }

  function fanTriangulate(pts) {
    // éventail depuis le centroïde (index n) : correct pour les formes étoilées
    var n = pts.length, tris = [];
    for (var i = 0; i < n; i++) tris.push([n, i, (i + 1) % n]);
    return tris;
  }

  // ===========================================================================
  // Mini bibliothèque mat4
  // ===========================================================================
  function mat4Perspective(fovY, aspect, near, far) {
    var f = 1 / Math.tan(fovY / 2), nf = 1 / (near - far);
    return new Float32Array([
      f / aspect, 0, 0, 0,
      0, f, 0, 0,
      0, 0, (far + near) * nf, -1,
      0, 0, 2 * far * near * nf, 0
    ]);
  }
  function v3sub(a, b) { return [a[0] - b[0], a[1] - b[1], a[2] - b[2]]; }
  function v3cross(a, b) { return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]]; }
  function v3norm(a) { var l = Math.hypot(a[0], a[1], a[2]) || 1; return [a[0] / l, a[1] / l, a[2] / l]; }
  function v3dot(a, b) { return a[0] * b[0] + a[1] * b[1] + a[2] * b[2]; }
  function mat4LookAt(eye, target, up) {
    var z = v3norm(v3sub(eye, target));
    var x = v3norm(v3cross(up, z));
    var y = v3cross(z, x);
    return new Float32Array([
      x[0], y[0], z[0], 0,
      x[1], y[1], z[1], 0,
      x[2], y[2], z[2], 0,
      -v3dot(x, eye), -v3dot(y, eye), -v3dot(z, eye), 1
    ]);
  }
  function mat4Mul(a, b) {
    var o = new Float32Array(16);
    for (var c = 0; c < 4; c++) for (var r = 0; r < 4; r++) {
      o[c * 4 + r] = a[r] * b[c * 4] + a[4 + r] * b[c * 4 + 1] + a[8 + r] * b[c * 4 + 2] + a[12 + r] * b[c * 4 + 3];
    }
    return o;
  }

  // ===========================================================================
  // Visualisateur WebGL
  // ===========================================================================
  var VERT_SRC = [
    'attribute vec3 aPos;',
    'attribute vec3 aNor;',
    'attribute float aAlpha;',
    'uniform mat4 uVP;',
    'varying vec3 vN; varying vec3 vP; varying float vA;',
    'void main(){ vN = aNor; vP = aPos; vA = aAlpha; gl_Position = uVP * vec4(aPos, 1.0); }'
  ].join('\n');

  var FRAG_SRC = [
    'precision mediump float;',
    'varying vec3 vN; varying vec3 vP; varying float vA;',
    'uniform vec3 uColor; uniform float uSpec; uniform float uShin;',
    'uniform vec3 uCam; uniform vec3 uLight; uniform vec3 uLight2;',
    'uniform float uUnlit; uniform float uAlpha;',
    'void main(){',
    '  if (uUnlit > 0.5) { gl_FragColor = vec4(uColor, uAlpha * vA); return; }',
    '  vec3 N = normalize(vN); vec3 V = normalize(uCam - vP);',
    '  vec3 L1 = normalize(uLight); vec3 L2 = normalize(uLight2);',
    '  float hemi = 0.5 + 0.5 * N.y;',
    '  vec3 amb = mix(vec3(0.42,0.42,0.45), vec3(0.98,0.98,1.0), hemi) * 0.42;',
    '  float d1 = max(dot(N, L1), 0.0); float d2 = max(dot(N, L2), 0.0);',
    '  vec3 H1 = normalize(L1 + V); float s1 = pow(max(dot(N, H1), 0.0), uShin) * uSpec;',
    '  vec3 H2 = normalize(L2 + V); float s2 = pow(max(dot(N, H2), 0.0), uShin) * uSpec * 0.35;',
    '  float fres = pow(1.0 - max(dot(N, V), 0.0), 4.0) * 0.06;',
    '  vec3 col = uColor * (amb + d1 * 0.72 + d2 * 0.28) + vec3(s1 + s2 + fres);',
    '  col = pow(clamp(col, 0.0, 1.0), vec3(1.0 / 2.2));',
    '  gl_FragColor = vec4(col, uAlpha * vA);',
    '}'
  ].join('\n');

  function createGLViewer(canvas, opts) {
    var gl = null;
    try {
      gl = canvas.getContext('webgl', { antialias: true, alpha: true, premultipliedAlpha: false, powerPreference: 'low-power' }) ||
           canvas.getContext('experimental-webgl', { antialias: true, alpha: true, premultipliedAlpha: false });
    } catch (e) { gl = null; }
    if (!gl) return null;

    function compile(type, src) {
      var s = gl.createShader(type);
      gl.shaderSource(s, src);
      gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(s) || 'shader');
      return s;
    }
    var prog;
    try {
      prog = gl.createProgram();
      gl.attachShader(prog, compile(gl.VERTEX_SHADER, VERT_SRC));
      gl.attachShader(prog, compile(gl.FRAGMENT_SHADER, FRAG_SRC));
      gl.linkProgram(prog);
      if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(prog) || 'link');
    } catch (e) { return null; }
    gl.useProgram(prog);

    var loc = {
      aPos: gl.getAttribLocation(prog, 'aPos'),
      aNor: gl.getAttribLocation(prog, 'aNor'),
      aAlpha: gl.getAttribLocation(prog, 'aAlpha'),
      uVP: gl.getUniformLocation(prog, 'uVP'),
      uColor: gl.getUniformLocation(prog, 'uColor'),
      uSpec: gl.getUniformLocation(prog, 'uSpec'),
      uShin: gl.getUniformLocation(prog, 'uShin'),
      uCam: gl.getUniformLocation(prog, 'uCam'),
      uLight: gl.getUniformLocation(prog, 'uLight'),
      uLight2: gl.getUniformLocation(prog, 'uLight2'),
      uUnlit: gl.getUniformLocation(prog, 'uUnlit'),
      uAlpha: gl.getUniformLocation(prog, 'uAlpha')
    };

    gl.enable(gl.DEPTH_TEST);
    gl.disable(gl.CULL_FACE);
    gl.enable(gl.BLEND);
    gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);

    var LIGHT1 = v3norm([0.45, 1.0, 0.55]);
    var LIGHT2 = v3norm([-0.7, 0.5, -0.4]);
    var SHADOW_DIR = LIGHT1;

    var STRIDE = 7 * 4;
    var meshes = {};

    function makeMesh(name, data) {
      var m = meshes[name];
      if (!m) {
        m = meshes[name] = { buf: gl.createBuffer(), count: 0 };
      }
      var arr = (data instanceof Float32Array) ? data : new Float32Array(data);
      gl.bindBuffer(gl.ARRAY_BUFFER, m.buf);
      gl.bufferData(gl.ARRAY_BUFFER, arr, gl.STATIC_DRAW);
      m.count = arr.length / 7;
    }

    function drawMesh(name, color, spec, shin, unlit, alpha, depthWrite) {
      var m = meshes[name];
      if (!m || !m.count) return;
      gl.bindBuffer(gl.ARRAY_BUFFER, m.buf);
      gl.enableVertexAttribArray(loc.aPos);
      gl.vertexAttribPointer(loc.aPos, 3, gl.FLOAT, false, STRIDE, 0);
      gl.enableVertexAttribArray(loc.aNor);
      gl.vertexAttribPointer(loc.aNor, 3, gl.FLOAT, false, STRIDE, 12);
      gl.enableVertexAttribArray(loc.aAlpha);
      gl.vertexAttribPointer(loc.aAlpha, 1, gl.FLOAT, false, STRIDE, 24);
      gl.uniform3fv(loc.uColor, color);
      gl.uniform1f(loc.uSpec, spec);
      gl.uniform1f(loc.uShin, shin);
      gl.uniform1f(loc.uUnlit, unlit ? 1 : 0);
      gl.uniform1f(loc.uAlpha, alpha == null ? 1 : alpha);
      gl.depthMask(depthWrite !== false);
      gl.drawArrays(gl.TRIANGLES, 0, m.count);
    }

    // ---- Construction géométrie ----
    var geo = { L: 160, D: 90, zTop: 78, color: [0, 0.4, 0.1], ok: false };

    function pushTri(out, a, b, c, n, alpha) {
      alpha = (alpha == null) ? 1 : alpha;
      out.push(a[0], a[1], a[2], n[0], n[1], n[2], alpha,
               b[0], b[1], b[2], n[0], n[1], n[2], alpha,
               c[0], c[1], c[2], n[0], n[1], n[2], alpha);
    }
    function pushQuad(out, a, b, c, d, n, alpha) {
      pushTri(out, a, b, c, n, alpha);
      pushTri(out, a, c, d, n, alpha);
    }
    function pushCylinder(out, cx, cz, r, y0, y1, segs) {
      for (var i = 0; i < segs; i++) {
        var a0 = (i / segs) * Math.PI * 2, a1 = ((i + 1) / segs) * Math.PI * 2;
        var x0 = cx + Math.cos(a0) * r, z0 = cz + Math.sin(a0) * r;
        var x1 = cx + Math.cos(a1) * r, z1 = cz + Math.sin(a1) * r;
        var n0 = [Math.cos(a0), 0, Math.sin(a0)], n1 = [Math.cos(a1), 0, Math.sin(a1)];
        // normales lissées par sommet
        out.push(x0, y0, z0, n0[0], n0[1], n0[2], 1,
                 x1, y0, z1, n1[0], n1[1], n1[2], 1,
                 x1, y1, z1, n1[0], n1[1], n1[2], 1);
        out.push(x0, y0, z0, n0[0], n0[1], n0[2], 1,
                 x1, y1, z1, n1[0], n1[1], n1[2], 1,
                 x0, y1, z0, n0[0], n0[1], n0[2], 1);
        // cap haut / bas
        pushTri(out, [cx, y1, cz], [x0, y1, z0], [x1, y1, z1], [0, 1, 0]);
        pushTri(out, [cx, y0, cz], [x1, y0, z1], [x0, y0, z0], [0, -1, 0]);
      }
    }
    function pushBox(out, x0, x1, y0, y1, z0, z1) {
      pushQuad(out, [x0, y1, z0], [x1, y1, z0], [x1, y1, z1], [x0, y1, z1], [0, 1, 0]);
      pushQuad(out, [x0, y0, z0], [x0, y0, z1], [x1, y0, z1], [x1, y0, z0], [0, -1, 0]);
      pushQuad(out, [x0, y0, z1], [x0, y1, z1], [x1, y1, z1], [x1, y0, z1], [0, 0, 1]);
      pushQuad(out, [x0, y0, z0], [x1, y0, z0], [x1, y1, z0], [x0, y1, z0], [0, 0, -1]);
      pushQuad(out, [x1, y0, z0], [x1, y0, z1], [x1, y1, z1], [x1, y1, z0], [1, 0, 0]);
      pushQuad(out, [x0, y0, z0], [x0, y1, z0], [x0, y1, z1], [x0, y0, z1], [-1, 0, 0]);
    }

    // Ombre douce : plusieurs couches du contour, dilatées et décalées selon la lumière
    function pushSoftShadow(out, contour, height, layers, spread, alphaEach) {
      var cx = 0, cz = 0;
      for (var i = 0; i < contour.length; i++) { cx += contour[i].x; cz += contour[i].z; }
      cx /= contour.length; cz /= contour.length;
      var offX = -(SHADOW_DIR[0] / SHADOW_DIR[1]) * height * 0.16;
      var offZ = -(SHADOW_DIR[2] / SHADOW_DIR[1]) * height * 0.16;
      for (var k = 0; k < layers; k++) {
        var grow = spread * (k / Math.max(1, layers - 1));
        var y = 0.06 + k * 0.01;
        var pts = [];
        for (i = 0; i < contour.length; i++) {
          var dx = contour[i].x - cx, dz = contour[i].z - cz;
          var len = Math.hypot(dx, dz) || 1;
          pts.push([cx + dx + (dx / len) * grow + offX, y, cz + dz + (dz / len) * grow + offZ]);
        }
        for (i = 0; i < pts.length; i++) {
          pushTri(out, [cx + offX, y, cz + offZ], pts[i], pts[(i + 1) % pts.length], [0, 1, 0], alphaEach);
        }
      }
    }

    function build(st) {
      var L = st.lengthCm, D = st.widthCm;
      var LEG_H = opts.legHeight, T = opts.topThickness, zTop = LEG_H + T;
      var PLATE = 12, PLATE_T = 0.8;

      var raw = cleanContour(st.points);
      var contour = [];
      for (var i = 0; i < raw.length; i++) contour.push({ x: (raw[i].x - 0.5) * L, z: (raw[i].y - 0.5) * D });

      // --- plateau ---
      var top = [];
      if (contour.length >= 3) {
        var pts2 = contour.map(function (p) { return { x: p.x, y: p.z }; });
        var tris = triangulate(pts2, !!st.fast);
        var cxs = 0, czs = 0;
        for (i = 0; i < contour.length; i++) { cxs += contour[i].x; czs += contour[i].z; }
        var centroid = { x: cxs / contour.length, y: czs / contour.length };
        function P(idx, y) { var p = (idx === pts2.length) ? centroid : pts2[idx]; return [p.x, y, p.y]; }
        for (i = 0; i < tris.length; i++) {
          var t = tris[i];
          pushTri(top, P(t[0], zTop), P(t[1], zTop), P(t[2], zTop), [0, 1, 0]);
          pushTri(top, P(t[0], LEG_H), P(t[2], LEG_H), P(t[1], LEG_H), [0, -1, 0]);
        }
        // chants avec normales lissées (bords arrondis visuellement)
        var n = contour.length;
        var edgeN = [];
        for (i = 0; i < n; i++) {
          var a = contour[i], b = contour[(i + 1) % n];
          var dx = b.x - a.x, dz = b.z - a.z;
          var nn = v3norm([dz, 0, -dx]);
          var mx = (a.x + b.x) / 2 - centroid.x, mz = (a.z + b.z) / 2 - centroid.y;
          if (nn[0] * mx + nn[2] * mz < 0) nn = [-nn[0], 0, -nn[2]];
          edgeN.push(nn);
        }
        for (i = 0; i < n; i++) {
          a = contour[i]; b = contour[(i + 1) % n];
          var nPrev = edgeN[(i + n - 1) % n], nCur = edgeN[i], nNext = edgeN[(i + 1) % n];
          // lissage uniquement si l'angle est doux (courbes) ; angle vif = facette nette
          var nA = (v3dot(nPrev, nCur) > 0.7) ? v3norm([nPrev[0] + nCur[0], 0, nPrev[2] + nCur[2]]) : nCur;
          var nB = (v3dot(nNext, nCur) > 0.7) ? v3norm([nNext[0] + nCur[0], 0, nNext[2] + nCur[2]]) : nCur;
          top.push(a.x, LEG_H, a.z, nA[0], nA[1], nA[2], 1,
                   b.x, LEG_H, b.z, nB[0], nB[1], nB[2], 1,
                   b.x, zTop, b.z, nB[0], nB[1], nB[2], 1);
          top.push(a.x, LEG_H, a.z, nA[0], nA[1], nA[2], 1,
                   b.x, zTop, b.z, nB[0], nB[1], nB[2], 1,
                   a.x, zTop, a.z, nA[0], nA[1], nA[2], 1);
        }
      }
      makeMesh('top', top);

      // --- pieds + platines (noir mat) ---
      var black = [];
      var legs = st.legPoints || [];
      for (i = 0; i < legs.length; i++) {
        var lx = (legs[i].x - 0.5) * L, lz = (legs[i].y - 0.5) * D;
        pushCylinder(black, lx, lz, opts.legRadius, 0, LEG_H - PLATE_T, 28);
        pushBox(black, lx - PLATE / 2, lx + PLATE / 2, LEG_H - PLATE_T, LEG_H, lz - PLATE / 2, lz + PLATE / 2);
      }
      makeMesh('black', black);

      // --- sol : disque dégradé ---
      var ground = [];
      var R = 420, segs = 64;
      for (i = 0; i < segs; i++) {
        var a0 = (i / segs) * Math.PI * 2, a1 = ((i + 1) / segs) * Math.PI * 2;
        ground.push(0, 0, 0, 0, 1, 0, 0.55,
                    Math.cos(a0) * R, 0, Math.sin(a0) * R, 0, 1, 0, 0,
                    Math.cos(a1) * R, 0, Math.sin(a1) * R, 0, 1, 0, 0);
      }
      makeMesh('ground', ground);

      // --- ombres ---
      var shadow = [];
      if (contour.length >= 3) pushSoftShadow(shadow, contour, zTop, 7, 9, 0.04);
      for (i = 0; i < legs.length; i++) {
        var c = [];
        var lx2 = (legs[i].x - 0.5) * L, lz2 = (legs[i].y - 0.5) * D;
        for (var k = 0; k < 18; k++) {
          var ang = (k / 18) * Math.PI * 2;
          c.push({ x: lx2 + Math.cos(ang) * opts.legRadius, z: lz2 + Math.sin(ang) * opts.legRadius });
        }
        pushSoftShadow(shadow, c, 0, 4, 3, 0.05);
      }
      makeMesh('shadow', shadow);

      geo.L = L; geo.D = D; geo.zTop = zTop;
      geo.color = hexToLinear(st.color);
      geo.ok = contour.length >= 3;
    }

    // ---- Caméra / orbite ----
    var cam = { theta: -0.62, phi: 0.40, zoom: 1, targetY: 0 };
    var PHI_MIN = 0.08, PHI_MAX = 1.35;
    var FOV = 30 * Math.PI / 180;
    var width = 2, height = 2, dpr = 1;

    function cameraEye() {
      var hx = geo.L / 2, hz = geo.D / 2, hy = geo.zTop / 2;
      var radius = Math.sqrt(hx * hx + hz * hz + hy * hy) + 8;
      var aspect = width / height;
      var fovH = 2 * Math.atan(Math.tan(FOV / 2) * aspect);
      var dist = radius / Math.sin(Math.min(FOV, fovH) / 2) * 1.04 * cam.zoom;
      var ty = geo.zTop * 0.5 + 2;
      var target = [0, ty, 0];
      var eye = [
        target[0] + dist * Math.cos(cam.phi) * Math.sin(cam.theta),
        target[1] + dist * Math.sin(cam.phi),
        target[2] + dist * Math.cos(cam.phi) * Math.cos(cam.theta)
      ];
      return { eye: eye, target: target, dist: dist };
    }

    function render() {
      gl.viewport(0, 0, canvas.width, canvas.height);
      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
      if (!geo.ok) return;

      var c = cameraEye();
      var proj = mat4Perspective(FOV, width / height, 5, c.dist * 4 + 2000);
      var view = mat4LookAt(c.eye, c.target, [0, 1, 0]);
      gl.uniformMatrix4fv(loc.uVP, false, mat4Mul(proj, view));
      gl.uniform3fv(loc.uCam, c.eye);
      gl.uniform3fv(loc.uLight, LIGHT1);
      gl.uniform3fv(loc.uLight2, LIGHT2);

      drawMesh('ground', [0.86, 0.86, 0.85], 0, 1, true, 1, true);
      drawMesh('shadow', [0.05, 0.05, 0.07], 0, 1, true, 1, false);
      drawMesh('black', [0.012, 0.012, 0.013], 0.10, 18, false, 1, true);
      drawMesh('top', geo.color, 0.22, 42, false, 1, true);
    }

    var raf = 0;
    function requestRender() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; render(); });
    }

    function resize(w, h, ratio) {
      width = Math.max(2, w); height = Math.max(2, h); dpr = ratio;
      canvas.width = Math.round(width * dpr);
      canvas.height = Math.round(height * dpr);
      requestRender();
    }

    // ---- Interactions : rotation (glisser), zoom (molette / pincement) ----
    var pointers = {};
    var dragging = false, lastX = 0, lastY = 0, pinchDist = 0;
    var animRaf = 0;

    function stopAnim() { if (animRaf) { cancelAnimationFrame(animRaf); animRaf = 0; } }

    canvas.addEventListener('pointerdown', function (e) {
      stopAnim();
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var keys = Object.keys(pointers);
      if (keys.length === 1) { dragging = true; lastX = e.clientX; lastY = e.clientY; canvas.classList.add('is-dragging'); }
      if (keys.length === 2) {
        var p = pointers[keys[0]], q = pointers[keys[1]];
        pinchDist = Math.hypot(p.x - q.x, p.y - q.y);
      }
      try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
      e.preventDefault();
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!pointers[e.pointerId]) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var keys = Object.keys(pointers);
      if (keys.length >= 2) {
        var p = pointers[keys[0]], q = pointers[keys[1]];
        var d = Math.hypot(p.x - q.x, p.y - q.y);
        if (pinchDist > 0) {
          cam.zoom = clamp(cam.zoom * (pinchDist / d), 0.55, 2.4);
          requestRender();
        }
        pinchDist = d;
        return;
      }
      if (!dragging) return;
      var dx = e.clientX - lastX, dy = e.clientY - lastY;
      lastX = e.clientX; lastY = e.clientY;
      cam.theta -= dx * 0.008;
      cam.phi = clamp(cam.phi + dy * 0.006, PHI_MIN, PHI_MAX);
      requestRender();
      e.preventDefault();
    });
    function endPointer(e) {
      delete pointers[e.pointerId];
      var keys = Object.keys(pointers);
      if (!keys.length) { dragging = false; pinchDist = 0; canvas.classList.remove('is-dragging'); }
      else if (keys.length === 1) { var p = pointers[keys[0]]; lastX = p.x; lastY = p.y; dragging = true; pinchDist = 0; }
    }
    canvas.addEventListener('pointerup', endPointer);
    canvas.addEventListener('pointercancel', endPointer);
    canvas.addEventListener('lostpointercapture', endPointer);

    canvas.addEventListener('wheel', function (e) {
      e.preventDefault();
      stopAnim();
      var k = Math.exp((e.deltaMode === 1 ? e.deltaY * 16 : e.deltaY) * 0.0012);
      cam.zoom = clamp(cam.zoom * k, 0.55, 2.4);
      requestRender();
    }, { passive: false });

    canvas.addEventListener('dblclick', function () { resetView(true); });

    // Clavier : flèches pour tourner, +/- pour zoomer
    canvas.tabIndex = 0;
    canvas.addEventListener('keydown', function (e) {
      var handled = true;
      if (e.key === 'ArrowLeft') cam.theta += 0.12;
      else if (e.key === 'ArrowRight') cam.theta -= 0.12;
      else if (e.key === 'ArrowUp') cam.phi = clamp(cam.phi + 0.08, PHI_MIN, PHI_MAX);
      else if (e.key === 'ArrowDown') cam.phi = clamp(cam.phi - 0.08, PHI_MIN, PHI_MAX);
      else if (e.key === '+' || e.key === '=') cam.zoom = clamp(cam.zoom * 0.9, 0.55, 2.4);
      else if (e.key === '-') cam.zoom = clamp(cam.zoom / 0.9, 0.55, 2.4);
      else handled = false;
      if (handled) { e.preventDefault(); stopAnim(); requestRender(); }
    });

    function animateTo(theta, phi, zoom, ms) {
      stopAnim();
      var t0 = performance.now();
      var s = { theta: cam.theta, phi: cam.phi, zoom: cam.zoom };
      // chemin le plus court pour theta
      var dTheta = theta - s.theta;
      dTheta = Math.atan2(Math.sin(dTheta), Math.cos(dTheta));
      function step(now) {
        var t = clamp((now - t0) / ms, 0, 1);
        var k = 1 - Math.pow(1 - t, 3);
        cam.theta = s.theta + dTheta * k;
        cam.phi = s.phi + (phi - s.phi) * k;
        cam.zoom = s.zoom + (zoom - s.zoom) * k;
        render();
        if (t < 1) animRaf = requestAnimationFrame(step); else animRaf = 0;
      }
      animRaf = requestAnimationFrame(step);
    }
    function resetView(animate) {
      if (animate) animateTo(-0.62, 0.40, 1, 700);
      else { cam.theta = -0.62; cam.phi = 0.40; cam.zoom = 1; requestRender(); }
    }
    function intro() {
      cam.theta = -1.25; cam.phi = 0.55; cam.zoom = 1.18;
      animateTo(-0.62, 0.40, 1, 1100);
    }

    return {
      update: function (st) { build(st); requestRender(); },
      resize: resize,
      resetView: resetView,
      intro: intro,
      isContextLost: function () { return gl.isContextLost(); }
    };
  }

  // ===========================================================================
  // Repli 2D (canvas) — rendu isométrique de la v1
  // ===========================================================================
  function render2DFallback(canvas, state, opts) {
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    var w = canvas.clientWidth, h = canvas.clientHeight;
    var dpr = Math.max(1, Math.min(2.5, window.devicePixelRatio || 1));
    canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, w, h);

    var angle = Math.PI / 6, cos = Math.cos(angle), sin = Math.sin(angle);
    var L = state.lengthCm, D = state.widthCm;
    var LEG_H = opts.legHeight, zTop = LEG_H + opts.topThickness;
    function project(x, y, z) { return { px: (x - y) * cos, py: (x + y) * sin - z }; }

    var pts = state.points;
    var projTop = [], projUnder = [];
    for (var i = 0; i < pts.length; i++) {
      projTop.push(project(pts[i].x * L, pts[i].y * D, zTop));
      projUnder.push(project(pts[i].x * L, pts[i].y * D, LEG_H));
    }
    var legs = (state.legPoints || []).map(function (p) { return { x: p.x * L, y: p.y * D }; });

    var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    function acc(p) { minX = Math.min(minX, p.px); maxX = Math.max(maxX, p.px); minY = Math.min(minY, p.py); maxY = Math.max(maxY, p.py); }
    projTop.forEach(acc);
    legs.forEach(function (l) { acc(project(l.x, l.y, 0)); });
    var pad = 40;
    var scale = Math.min((w - pad * 2) / Math.max(1e-6, maxX - minX), (h - pad * 2) / Math.max(1e-6, maxY - minY));
    var ox = (w - (maxX - minX) * scale) / 2 - minX * scale;
    var oy = (h - (maxY - minY) * scale) / 2 - minY * scale + 20;
    function P(pp) { return { x: ox + pp.px * scale, y: oy + pp.py * scale }; }

    var baseRgb = hexToRgb(state.color);
    var topRgb = shadeRgb(baseRgb, 0.05), sideRgb = shadeRgb(baseRgb, -0.12), sideRgb2 = shadeRgb(baseRgb, -0.18);

    var legRpx = opts.legRadius * scale;
    legs.forEach(function (l) {
      var bottom = P(project(l.x, l.y, 0)), top = P(project(l.x, l.y, LEG_H));
      ctx.fillStyle = 'rgba(0,0,0,0.88)';
      ctx.fillRect(bottom.x - legRpx, top.y, legRpx * 2, Math.max(2, bottom.y - top.y));
      ctx.beginPath(); ctx.ellipse(bottom.x, top.y, legRpx, Math.max(2, legRpx * 0.45), 0, 0, Math.PI * 2); ctx.fillStyle = 'rgba(0,0,0,0.92)'; ctx.fill();
      ctx.beginPath(); ctx.ellipse(bottom.x, bottom.y, legRpx, Math.max(2, legRpx * 0.45), 0, 0, Math.PI * 2); ctx.fillStyle = 'rgba(0,0,0,0.70)'; ctx.fill();
    });

    var top2D = projTop.map(P), under2D = projUnder.map(P);
    ctx.lineWidth = 1;
    for (i = 0; i < top2D.length - 1; i++) {
      ctx.beginPath();
      ctx.moveTo(under2D[i].x, under2D[i].y); ctx.lineTo(under2D[i + 1].x, under2D[i + 1].y);
      ctx.lineTo(top2D[i + 1].x, top2D[i + 1].y); ctx.lineTo(top2D[i].x, top2D[i].y);
      ctx.closePath();
      ctx.fillStyle = (i % 2 === 0) ? rgbCss(sideRgb, 0.95) : rgbCss(sideRgb2, 0.95);
      ctx.fill(); ctx.strokeStyle = 'rgba(0,0,0,0.12)'; ctx.stroke();
    }
    if (top2D.length) {
      ctx.beginPath(); ctx.moveTo(top2D[0].x, top2D[0].y);
      for (i = 1; i < top2D.length; i++) ctx.lineTo(top2D[i].x, top2D[i].y);
      ctx.closePath(); ctx.fillStyle = rgbCss(topRgb, 0.98); ctx.fill();
      ctx.strokeStyle = 'rgba(0,0,0,0.18)'; ctx.stroke();
    }
  }

  // ===========================================================================
  // Configurateur
  // ===========================================================================
  function initConfigurator(root) {
    if (root.__tcfgInit) return;
    root.__tcfgInit = true;

    var BILLING_VARIANT_ID = parseInt(root.getAttribute('data-billing-variant-id'), 10) || 0;
    var BILLING_HANDLE = root.getAttribute('data-billing-handle') || '';
    var RAL_SUPPLEMENT = parseInt(root.getAttribute('data-ral-supplement'), 10) || 155;
    var RAL_DELAY_WEEKS = parseInt(root.getAttribute('data-ral-delay-weeks'), 10) || 3;

    // Contraintes
    var LENGTH_MIN_CM = 60, LENGTH_MAX_CM = 245;
    var WIDTH_MIN_CM = 40, WIDTH_MAX_CM = 147;

    // Prix
    var PRICE_PER_M2 = 220;

    // Pieds / rendu
    var OPTS = { legHeight: 74, topThickness: 2.1, legRadius: 3.2, legPlateMargin: 8 };

    var els = {
      viewerCanvas: root.querySelector('[data-role="viewer"]'),
      viewerWrap: root.querySelector('[data-role="viewerWrap"]'),
      viewerBadge: root.querySelector('[data-role="viewerBadge"]'),
      viewerDims: root.querySelector('[data-role="viewerDims"]'),
      viewerHint: root.querySelector('[data-role="viewerHint"]'),
      viewReset: root.querySelector('[data-role="viewReset"]'),

      svg: root.querySelector('svg[data-role="draw"]'),
      templateRect: root.querySelector('[data-role="templateRect"]'),
      hitRect: root.querySelector('[data-role="hit"]'),
      hint: root.querySelector('[data-role="hint"]'),
      shapePath: root.querySelector('[data-role="shape"]'),

      lengthRange: root.querySelector('[data-role="lengthRange"]'),
      lengthNumber: root.querySelector('[data-role="lengthNumber"]'),
      widthRange: root.querySelector('[data-role="widthRange"]'),
      widthNumber: root.querySelector('[data-role="widthNumber"]'),

      clearBtn: root.querySelector('[data-role="clear"]'),
      resetBtn: root.querySelector('[data-role="reset"]'),

      areaText: root.querySelector('[data-role="areaText"]'),
      basePriceText: root.querySelector('[data-role="basePriceText"]'),
      priceText: root.querySelector('[data-role="priceText"]'),
      ralPriceLine: root.querySelector('[data-role="ralPriceLine"]'),
      ralSupplementText: root.querySelector('[data-role="ralSupplementText"]'),
      ralDelayLine: root.querySelector('[data-role="ralDelayLine"]'),

      ralToggle: root.querySelector('[data-role="ralToggle"]'),
      ralDot: root.querySelector('[data-role="ralDot"]'),
      ralBtnSub: root.querySelector('[data-role="ralBtnSub"]'),
      ralPanel: root.querySelector('[data-role="ralPanel"]'),
      ralSearch: root.querySelector('[data-role="ralSearch"]'),
      ralSelected: root.querySelector('[data-role="ralSelected"]'),
      ralGrid: root.querySelector('[data-role="ralGrid"]'),

      addBtn: root.querySelector('[data-role="addToCart"]'),
      cartMsg: root.querySelector('[data-role="cartMsg"]')
    };
    if (!els.viewerCanvas || !els.svg) return;

    // -------------------------------------------------------------------------
    // State
    // -------------------------------------------------------------------------
    var defaultState = {
      lengthCm: 160,
      widthCm: 90,
      color: '#00a651',
      colorName: 'Vert',
      ral: null,             // { code, name, hex } quand RAL sur mesure sélectionné
      shapeMode: 'freehand',
      shapeType: 'freehand',
      points: makePresetPoints('rectangle'),
      areaM2: 0,
      priceBaseExact: 0,
      priceBaseRounded: 0,
      priceTotalRounded: 0
    };
    var state = JSON.parse(JSON.stringify(defaultState));
    state.legRect = { x0: 0.12, x1: 0.88, y0: 0.12, y1: 0.88, ok: false };
    state.legRectDirty = true;

    function markLegRectDirty() { state.legRectDirty = true; }
    function ensureLegRect() {
      if (!state.legRectDirty) return state.legRect;
      state.legRect = largestInscribedRect(state.points);
      state.legRectDirty = false;
      return state.legRect;
    }
    function legPointsNorm() {
      var legRect = ensureLegRect();
      var L = state.lengthCm, D = state.widthCm;
      var mx = OPTS.legPlateMargin / Math.max(1, L);
      var my = OPTS.legPlateMargin / Math.max(1, D);
      mx = Math.min(mx, (legRect.x1 - legRect.x0) * 0.49);
      my = Math.min(my, (legRect.y1 - legRect.y0) * 0.49);
      return [
        { x: legRect.x0 + mx, y: legRect.y0 + my },
        { x: legRect.x1 - mx, y: legRect.y0 + my },
        { x: legRect.x1 - mx, y: legRect.y1 - my },
        { x: legRect.x0 + mx, y: legRect.y1 - my }
      ];
    }

    // -------------------------------------------------------------------------
    // Formes
    // -------------------------------------------------------------------------
    function makePresetPoints(type) {
      function seg(n) { return Math.max(24, n | 0); }
      if (type === 'rectangle') return [{ x: 0, y: 0 }, { x: 1, y: 0 }, { x: 1, y: 1 }, { x: 0, y: 1 }, { x: 0, y: 0 }];
      if (type === 'rounded') {
        var r = 0.18, n = seg(40), pts = [];
        var corners = [
          { cx: r, cy: r, a0: Math.PI, a1: 1.5 * Math.PI },
          { cx: 1 - r, cy: r, a0: 1.5 * Math.PI, a1: 2 * Math.PI },
          { cx: 1 - r, cy: 1 - r, a0: 0, a1: 0.5 * Math.PI },
          { cx: r, cy: 1 - r, a0: 0.5 * Math.PI, a1: Math.PI }
        ];
        for (var c = 0; c < corners.length; c++) {
          var cc = corners[c];
          for (var i = 0; i <= n / 4; i++) {
            var t = i / (n / 4), a = cc.a0 + (cc.a1 - cc.a0) * t;
            pts.push({ x: clamp01(cc.cx + Math.cos(a) * r), y: clamp01(cc.cy + Math.sin(a) * r) });
          }
        }
        pts.push({ x: pts[0].x, y: pts[0].y });
        return pts;
      }
      if (type === 'oval' || type === 'circle') {
        n = seg(72);
        var rx = 0.5, ry = (type === 'circle') ? 0.5 : 0.36, cx = 0.5, cy = 0.5;
        pts = [];
        for (i = 0; i <= n; i++) {
          a = (i / n) * Math.PI * 2;
          pts.push({ x: clamp01(cx + Math.cos(a) * rx), y: clamp01(cy + Math.sin(a) * ry) });
        }
        pts[pts.length - 1] = { x: pts[0].x, y: pts[0].y };
        return pts;
      }
      return [{ x: 0, y: 0 }, { x: 1, y: 0 }, { x: 1, y: 1 }, { x: 0, y: 1 }, { x: 0, y: 0 }];
    }

    function computeTemplateRect() {
      var VB_W = 1000, VB_H = 700, margin = 80;
      var availW = VB_W - margin * 2, availH = VB_H - margin * 2;
      var ratio = state.lengthCm / state.widthCm, availRatio = availW / availH;
      var w, h;
      if (ratio >= availRatio) { w = availW; h = w / ratio; } else { h = availH; w = h * ratio; }
      return { x: (VB_W - w) / 2, y: (VB_H - h) / 2, w: w, h: h };
    }

    function pointsToSvgPath(points, rect) {
      if (!points || points.length < 2) return '';
      function toXY(p) { return { x: rect.x + p.x * rect.w, y: rect.y + p.y * rect.h }; }
      var first = toXY(points[0]);
      var d = 'M ' + first.x.toFixed(2) + ' ' + first.y.toFixed(2);
      for (var i = 1; i < points.length; i++) { var pt = toXY(points[i]); d += ' L ' + pt.x.toFixed(2) + ' ' + pt.y.toFixed(2); }
      return d + ' Z';
    }

    function normalizeToFill(points) {
      var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
      for (var i = 0; i < points.length; i++) {
        var p = points[i];
        minX = Math.min(minX, p.x); minY = Math.min(minY, p.y); maxX = Math.max(maxX, p.x); maxY = Math.max(maxY, p.y);
      }
      var w = Math.max(1e-6, maxX - minX), h = Math.max(1e-6, maxY - minY);
      var out = [];
      for (i = 0; i < points.length; i++) { p = points[i]; out.push({ x: clamp01((p.x - minX) / w), y: clamp01((p.y - minY) / h) }); }
      if (out.length > 2) out[out.length - 1] = { x: out[0].x, y: out[0].y };
      var MAX = 220;
      if (out.length > MAX) {
        var step = out.length / MAX, sampled = [];
        for (i = 0; i < MAX; i++) sampled.push(out[Math.floor(i * step)]);
        sampled[sampled.length - 1] = { x: sampled[0].x, y: sampled[0].y };
        return sampled;
      }
      return out;
    }

    // -------------------------------------------------------------------------
    // Dessin (SVG)
    // -------------------------------------------------------------------------
    var isDrawing = false, rawPoints = [], lastAdded = null;

    function svgPointFromEvent(evt) {
      var pt = els.svg.createSVGPoint();
      pt.x = evt.clientX; pt.y = evt.clientY;
      var ctm = els.svg.getScreenCTM();
      if (!ctm) return { x: 0, y: 0 };
      var p = pt.matrixTransform(ctm.inverse());
      return { x: p.x, y: p.y };
    }
    function addRawPoint(pNorm) {
      var minDist = 0.012;
      if (!lastAdded) { rawPoints.push(pNorm); lastAdded = pNorm; return; }
      var dx = pNorm.x - lastAdded.x, dy = pNorm.y - lastAdded.y;
      if ((dx * dx + dy * dy) >= (minDist * minDist)) { rawPoints.push(pNorm); lastAdded = pNorm; }
    }

    function renderDraw() {
      var rect = computeTemplateRect();
      ['templateRect', 'hitRect'].forEach(function (k) {
        els[k].setAttribute('x', rect.x.toFixed(2)); els[k].setAttribute('y', rect.y.toFixed(2));
        els[k].setAttribute('width', rect.w.toFixed(2)); els[k].setAttribute('height', rect.h.toFixed(2));
      });
      els.hint.textContent = (state.shapeMode === 'freehand')
        ? T('hint_draw', 'Mode dessin : maintenez et tracez dans le gabarit')
        : T('hint_preset', 'Forme de base : ajustez longueur/largeur/couleur');
      var rgb = hexToRgb(state.color);
      els.shapePath.setAttribute('fill', 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',0.85)');
      els.shapePath.setAttribute('d', pointsToSvgPath(state.points, rect) || '');
      els.hitRect.style.cursor = (state.shapeMode === 'freehand') ? 'crosshair' : 'default';
    }

    // -------------------------------------------------------------------------
    // Visualisateur : WebGL, repli 2D
    // -------------------------------------------------------------------------
    var viewer = null;
    try { viewer = createGLViewer(els.viewerCanvas, OPTS); } catch (e) { viewer = null; }
    if (viewer) {
      els.viewerCanvas.addEventListener('webglcontextlost', function (e) { e.preventDefault(); }, false);
      els.viewerCanvas.addEventListener('webglcontextrestored', function () {
        try { viewer = createGLViewer(els.viewerCanvas, OPTS); } catch (err) { viewer = null; }
        renderViewer();
      }, false);
    } else {
      if (els.viewerBadge) { els.viewerBadge.textContent = '2D'; els.viewerBadge.classList.add('is-2d'); }
      if (els.viewerHint) els.viewerHint.textContent = T('viewer_hint_2d', 'Vue en perspective (plateau + 4 pieds cylindriques 74 cm)');
      if (els.viewReset) els.viewReset.hidden = true;
      els.viewerCanvas.style.cursor = 'default';
    }

    function renderViewer() {
      var snapshot = {
        lengthCm: state.lengthCm, widthCm: state.widthCm,
        color: state.color, points: state.points,
        legPoints: legPointsNorm(), fast: isDrawing
      };
      if (viewer) viewer.update(snapshot);
      else render2DFallback(els.viewerCanvas, snapshot, OPTS);
      if (els.viewerDims) els.viewerDims.textContent = state.lengthCm + ' × ' + state.widthCm + ' cm';
    }

    function setupViewerResize() {
      var wrap = els.viewerWrap || els.viewerCanvas.parentElement;
      function doResize() {
        var r = wrap.getBoundingClientRect();
        var dpr = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
        if (viewer) viewer.resize(r.width, r.height, dpr);
        else render2DFallback(els.viewerCanvas, { lengthCm: state.lengthCm, widthCm: state.widthCm, color: state.color, points: state.points, legPoints: legPointsNorm() }, OPTS);
      }
      if ('ResizeObserver' in window) { new ResizeObserver(doResize).observe(wrap); }
      else window.addEventListener('resize', doResize);
      doResize();
    }

    // -------------------------------------------------------------------------
    // Prix
    // -------------------------------------------------------------------------
    function updatePrice() {
      var areaM2 = (state.lengthCm / 100) * (state.widthCm / 100);
      var priceExact = areaM2 * PRICE_PER_M2;
      var priceRounded = Math.round(priceExact);
      var supplement = state.ral ? RAL_SUPPLEMENT : 0;

      state.areaM2 = areaM2;
      state.priceBaseExact = priceExact;
      state.priceBaseRounded = priceRounded;
      state.priceTotalRounded = priceRounded + supplement;

      if (els.areaText) els.areaText.textContent = areaM2.toFixed(2) + ' m²';
      if (els.basePriceText) els.basePriceText.textContent = formatEuroFRFromEuros(priceRounded);
      if (els.ralSupplementText) els.ralSupplementText.textContent = formatEuroFRFromEuros(RAL_SUPPLEMENT);
      if (els.ralPriceLine) els.ralPriceLine.hidden = !state.ral;
      if (els.ralDelayLine) els.ralDelayLine.hidden = !state.ral;
      if (els.priceText) els.priceText.textContent = formatEuroFRFromEuros(state.priceTotalRounded);
    }

    function buildShapeHandle() {
      if (state.shapeMode === 'freehand') return 'libre';
      return state.shapeType || 'forme';
    }

    // -------------------------------------------------------------------------
    // Panier
    // -------------------------------------------------------------------------
    function setCartMsg(txt, isError) {
      if (!els.cartMsg) return;
      els.cartMsg.textContent = txt || '';
      els.cartMsg.style.color = isError ? 'rgba(180,0,0,0.85)' : '';
    }
    function addToCart(variantId, quantity, properties) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity, properties: properties })
      }).then(function (res) {
        if (!res.ok) return res.text().then(function (t) { throw new Error(t || ('HTTP ' + res.status)); });
        return res.json();
      });
    }
    function onAddToCart() {
      if (!BILLING_VARIANT_ID) { setCartMsg(T('err_billing', 'Produit de facturation introuvable (handle: {handle}).', { handle: BILLING_HANDLE }), true); return; }
      if (els.ralPanel && !els.ralPanel.hidden && !state.ral) {
        setCartMsg(T('err_ral_pick', 'Choisissez une teinte RAL dans le nuancier, ou revenez à une couleur standard.'), true);
        if (els.ralSearch) els.ralSearch.focus();
        return;
      }
      var eurosQty = parseInt(state.priceTotalRounded, 10) || 0;
      if (eurosQty <= 0) { setCartMsg(T('err_price', 'Prix invalide.'), true); return; }

      var colorHandle = handleize(state.colorName);
      var shapeHandle = handleize(buildShapeHandle());

      var props = {
        "table_length_cm": String(state.lengthCm),
        "table_width_cm": String(state.widthCm),
        "area_m2": state.areaM2.toFixed(2),

        "color_name": state.colorName,
        "color_hex": state.color,
        "data_color_handle": colorHandle,

        "shape_mode": state.shapeMode,
        "shape_type": buildShapeHandle(),
        "data_shape_handle": shapeHandle,

        "price_exact_eur": formatEuroFRFromEuros(state.priceBaseExact),
        "price_charged_eur_rounded": formatEuroFRFromEuros(state.priceTotalRounded)
      };
      if (state.ral) {
        props["ral_custom"] = "Oui";
        props["ral_code"] = "RAL " + state.ral.code;
        props["ral_name"] = state.ral.name;
        props["ral_supplement_eur"] = formatEuroFRFromEuros(RAL_SUPPLEMENT);
        props["delai_supplementaire"] = RAL_DELAY_WEEKS + " semaines";
      }

      if (els.addBtn) els.addBtn.disabled = true;
      setCartMsg(T('cart_adding', 'Ajout au panier…'));
      addToCart(BILLING_VARIANT_ID, eurosQty, props)
        .then(function () { window.location.href = '/cart'; })
        .catch(function (err) { setCartMsg((err && err.message) ? err.message : T('err_cart', 'Erreur lors de l’ajout au panier.'), true); })
        .finally(function () { if (els.addBtn) els.addBtn.disabled = false; });
    }

    // -------------------------------------------------------------------------
    // UI
    // -------------------------------------------------------------------------
    function renderAll() {
      renderDraw();
      renderViewer();
      updatePrice();
    }

    function syncDims(from) {
      var len = parseInt((from === 'range') ? els.lengthRange.value : els.lengthNumber.value, 10);
      var wid = parseInt((from === 'range') ? els.widthRange.value : els.widthNumber.value, 10);
      if (isFinite(len)) state.lengthCm = clamp(len, LENGTH_MIN_CM, LENGTH_MAX_CM);
      if (isFinite(wid)) state.widthCm = clamp(wid, WIDTH_MIN_CM, WIDTH_MAX_CM);
      els.lengthRange.value = String(state.lengthCm); els.lengthNumber.value = String(state.lengthCm);
      els.widthRange.value = String(state.widthCm); els.widthNumber.value = String(state.widthCm);
      renderAll();
    }

    function refreshSwatches() {
      var swatches = root.querySelectorAll('[data-role="colorSwatch"]');
      for (var i = 0; i < swatches.length; i++) {
        var btn = swatches[i];
        btn.classList.toggle('is-active', !state.ral && btn.getAttribute('data-color') === state.color);
      }
      if (els.ralToggle) {
        els.ralToggle.classList.toggle('is-active', !!state.ral);
        els.ralToggle.setAttribute('aria-expanded', (els.ralPanel && !els.ralPanel.hidden) ? 'true' : 'false');
      }
      if (els.ralDot) {
        if (state.ral) { els.ralDot.classList.remove('tcfg__colorDot--ral'); els.ralDot.style.setProperty('--sw', state.ral.hex); }
        else { els.ralDot.classList.add('tcfg__colorDot--ral'); els.ralDot.style.removeProperty('--sw'); }
      }
      if (els.ralBtnSub) {
        els.ralBtnSub.textContent = state.ral
          ? ('RAL ' + state.ral.code + ' · ' + ralLabel(state.ral) + ' · +' + RAL_SUPPLEMENT + ' € · ' + T('ral_delay_weeks', '+{weeks} semaines de délai', { weeks: RAL_DELAY_WEEKS }))
          : (T('ral_chart', 'Nuancier RAL Classic') + ' · +' + RAL_SUPPLEMENT + ' € · ' + T('ral_delay_weeks', '+{weeks} semaines de délai', { weeks: RAL_DELAY_WEEKS }));
      }
    }

    function setColor(hex, name) {
      state.ral = null;
      state.color = hex || '#00a651';
      state.colorName = name || state.color;
      if (els.ralPanel) els.ralPanel.hidden = true;
      refreshSwatches();
      renderAll();
    }

    function setRal(entry) {
      state.ral = { code: entry.code, name: entry.name, hex: entry.hex };
      state.color = entry.hex;
      state.colorName = 'RAL ' + entry.code + ' ' + entry.name;
      refreshSwatches();
      refreshRalSelected();
      renderAll();
    }

    function refreshRalSelected() {
      if (!els.ralSelected) return;
      if (state.ral) {
        els.ralSelected.innerHTML = '';
        var dot = document.createElement('span');
        dot.className = 'tcfg__colorDot';
        dot.style.setProperty('--sw', state.ral.hex);
        var txt = document.createElement('span');
        txt.textContent = 'RAL ' + state.ral.code + ' ';
        var small = document.createElement('small');
        small.textContent = ralLabel(state.ral);
        txt.appendChild(small);
        els.ralSelected.appendChild(dot);
        els.ralSelected.appendChild(txt);
      } else {
        els.ralSelected.textContent = T('ral_choose', 'Choisissez une teinte dans le nuancier');
      }
      var sws = els.ralGrid ? els.ralGrid.querySelectorAll('.tcfg__ralSw') : [];
      for (var i = 0; i < sws.length; i++) {
        var active = !!state.ral && sws[i].getAttribute('data-ral') === state.ral.code;
        sws[i].classList.toggle('is-active', active);
        sws[i].setAttribute('aria-selected', active ? 'true' : 'false');
      }
    }

    function buildRalGrid() {
      if (!els.ralGrid) return;
      var frag = document.createDocumentFragment();
      RAL.forEach(function (entry) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tcfg__ralSw';
        b.setAttribute('role', 'option');
        b.setAttribute('aria-selected', 'false');
        b.setAttribute('data-ral', entry.code);
        var label = ralLabel(entry);
        b.setAttribute('data-search', foldText(entry.code + ' ' + entry.name + (label !== entry.name ? ' ' + label : '')));
        b.title = 'RAL ' + entry.code + ' — ' + label;
        b.setAttribute('aria-label', 'RAL ' + entry.code + ' ' + label);
        b.style.setProperty('--sw', entry.hex);
        b.addEventListener('click', function () { setRal(entry); });
        frag.appendChild(b);
      });
      var empty = document.createElement('div');
      empty.className = 'tcfg__ralEmpty';
      empty.hidden = true;
      empty.textContent = T('ral_empty', 'Aucune teinte ne correspond à cette recherche.');
      empty.setAttribute('data-role', 'ralEmpty');
      els.ralGrid.appendChild(frag);
      els.ralGrid.appendChild(empty);
    }

    function filterRal(q) {
      if (!els.ralGrid) return;
      var needle = foldText(q).trim().replace(/^ral\s*/, '');
      var sws = els.ralGrid.querySelectorAll('.tcfg__ralSw');
      var shown = 0;
      for (var i = 0; i < sws.length; i++) {
        var ok = !needle || sws[i].getAttribute('data-search').indexOf(needle) !== -1;
        sws[i].classList.toggle('is-hidden', !ok);
        if (ok) shown++;
      }
      var empty = els.ralGrid.querySelector('[data-role="ralEmpty"]');
      if (empty) empty.hidden = shown > 0;
    }

    function toggleRalPanel(open) {
      if (!els.ralPanel) return;
      els.ralPanel.hidden = !open;
      refreshSwatches();
      if (open && els.ralSearch) {
        try { els.ralSearch.focus({ preventScroll: true }); } catch (e) {}
      }
    }

    function setShapeMode(mode, type) {
      state.shapeMode = mode;
      state.shapeType = type || mode;
      var btns = root.querySelectorAll('.tcfg__shapeBtn');
      for (var i = 0; i < btns.length; i++) {
        var s = btns[i].getAttribute('data-shape');
        var active = (mode === 'freehand' && s === 'freehand') || (mode === 'preset' && s === type);
        btns[i].classList.toggle('is-active', !!active);
      }
      if (mode === 'preset') { state.points = makePresetPoints(type); markLegRectDirty(); }
      renderAll();
    }

    // Formes
    var shapeBtns = root.querySelectorAll('.tcfg__shapeBtn');
    for (var i = 0; i < shapeBtns.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          var s = btn.getAttribute('data-shape');
          if (s === 'freehand') setShapeMode('freehand', 'freehand'); else setShapeMode('preset', s);
        });
      })(shapeBtns[i]);
    }

    // Dimensions
    if (els.lengthRange) els.lengthRange.addEventListener('input', function () { syncDims('range'); });
    if (els.widthRange) els.widthRange.addEventListener('input', function () { syncDims('range'); });
    if (els.lengthNumber) els.lengthNumber.addEventListener('change', function () { syncDims('number'); });
    if (els.widthNumber) els.widthNumber.addEventListener('change', function () { syncDims('number'); });

    // Couleurs
    var colorBtns = root.querySelectorAll('[data-role="colorSwatch"]');
    for (i = 0; i < colorBtns.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () { setColor(btn.getAttribute('data-color'), btn.getAttribute('data-color-name')); });
      })(colorBtns[i]);
    }

    // RAL sur mesure
    buildRalGrid();
    if (els.ralToggle) els.ralToggle.addEventListener('click', function () {
      var open = els.ralPanel ? els.ralPanel.hidden : false;
      toggleRalPanel(open);
    });
    if (els.ralSearch) {
      els.ralSearch.addEventListener('input', function () { filterRal(els.ralSearch.value); });
      els.ralSearch.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        var first = els.ralGrid && els.ralGrid.querySelector('.tcfg__ralSw:not(.is-hidden)');
        if (first) first.click();
      });
    }

    // Vue 3D
    if (els.viewReset) els.viewReset.addEventListener('click', function () { if (viewer) viewer.resetView(true); });

    // Effacer / réinitialiser
    if (els.clearBtn) els.clearBtn.addEventListener('click', function () {
      state.points = makePresetPoints('rectangle');
      markLegRectDirty();
      setShapeMode('freehand', 'freehand');
      setCartMsg('');
    });
    if (els.resetBtn) els.resetBtn.addEventListener('click', function () {
      state.lengthCm = clamp(defaultState.lengthCm, LENGTH_MIN_CM, LENGTH_MAX_CM);
      state.widthCm = clamp(defaultState.widthCm, WIDTH_MIN_CM, WIDTH_MAX_CM);
      els.lengthRange.value = String(state.lengthCm); els.lengthNumber.value = String(state.lengthCm);
      els.widthRange.value = String(state.widthCm); els.widthNumber.value = String(state.widthCm);
      state.points = makePresetPoints('rectangle');
      markLegRectDirty();
      if (els.ralSearch) { els.ralSearch.value = ''; filterRal(''); }
      state.ral = null;
      refreshRalSelected();
      setShapeMode('freehand', 'freehand');
      setColor('#00a651', 'Vert');
      if (viewer) viewer.resetView(true);
      setCartMsg('');
    });

    // Dessin
    function getNormFromSvg(svgXY) {
      var rect = computeTemplateRect();
      return { x: clamp01((svgXY.x - rect.x) / rect.w), y: clamp01((svgXY.y - rect.y) / rect.h) };
    }
    function startDraw(evt) {
      if (state.shapeMode !== 'freehand') return;
      isDrawing = true; rawPoints = []; lastAdded = null;
      if (els.hitRect && els.hitRect.setPointerCapture) { try { els.hitRect.setPointerCapture(evt.pointerId); } catch (e) {} }
      addRawPoint(getNormFromSvg(svgPointFromEvent(evt)));
      state.points = makePresetPoints('rectangle');
      markLegRectDirty();
      renderAll();
    }
    function moveDraw(evt) {
      if (!isDrawing) return;
      addRawPoint(getNormFromSvg(svgPointFromEvent(evt)));
      if (rawPoints.length >= 2) {
        var live = rawPoints.slice();
        if (live.length > 2) live.push(live[0]);
        state.points = live;
        markLegRectDirty();
        renderAll();
      }
    }
    function endDraw() {
      if (!isDrawing) return;
      isDrawing = false;
      if (rawPoints.length < 6) { state.points = makePresetPoints('rectangle'); markLegRectDirty(); renderAll(); return; }
      state.points = normalizeToFill(rawPoints);
      markLegRectDirty();
      renderAll();
    }
    if (els.hitRect) {
      els.hitRect.addEventListener('pointerdown', function (e) { e.preventDefault(); startDraw(e); });
      els.hitRect.addEventListener('pointermove', function (e) { e.preventDefault(); moveDraw(e); });
      els.hitRect.addEventListener('pointerup', function (e) { e.preventDefault(); endDraw(); });
      els.hitRect.addEventListener('pointercancel', function (e) { e.preventDefault(); endDraw(); });
    }

    // Panier
    if (els.addBtn) els.addBtn.addEventListener('click', onAddToCart);

    // Init
    if (els.lengthRange) els.lengthRange.max = String(LENGTH_MAX_CM);
    if (els.lengthNumber) els.lengthNumber.max = String(LENGTH_MAX_CM);
    if (els.widthRange) els.widthRange.max = String(WIDTH_MAX_CM);
    if (els.widthNumber) els.widthNumber.max = String(WIDTH_MAX_CM);

    state.color = '#00a651'; state.colorName = 'Vert'; state.ral = null;
    refreshSwatches();
    refreshRalSelected();
    setShapeMode('freehand', 'freehand');
    setupViewerResize();
    renderAll();
    if (viewer) viewer.intro();

    // Exposé pour tests / debug
    root.__tcfg = { state: state, setRal: setRal, setColor: setColor, setShapeMode: setShapeMode, syncDims: syncDims, hasWebGL: !!viewer, RAL: RAL };
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-tcfg-root]');
    for (var i = 0; i < roots.length; i++) {
      try { initConfigurator(roots[i]); } catch (e) { if (window.console) console.error('[tcfg]', e); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  // Éditeur de thème Shopify : re-rendu des sections
  document.addEventListener('shopify:section:load', initAll);
})();
